import { dispatchErrorWrap, dispatchSuccessWrap } from './genericActions'

import { actionTypes } from '../types'
import { constants } from '../../App.constants';
import moment from 'moment'

import axios from 'axios';

export const makeCardAsDefault = (cardId, customerId, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            cardId: cardId
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", data, headers)
            dispatchSuccessWrap(actionTypes.MAKE_CARD_DEFAULT, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }

}

export const getBankAccountToken = (plaid_link_public_token, account_id, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const data = {
            plaid_link_public_token: plaid_link_public_token,
            account_id: account_id
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/create_bank_token', data, headers)
            dispatchSuccessWrap(actionTypes.CREATE_BANK_TOKEN, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }

}

export const getLinkAccountToken = (user, redirectUri, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const data = {
            clientName: 'Tanglewood Resort',
            redirectUri: redirectUri
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/user/' + user + '/create_link_token', data, headers);
            dispatchSuccessWrap(actionTypes.GET_LINK_TOKEN, {
                token: payload.link_token
            }, dispatch)

            cb(null, payload)
        } catch (error) {
            cb(error)
        }
    }
}



export const getFutureTeeTickets = (cb) => {
    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            const payload = await axios.get(constants.ticketsBaseUrl + '/calendar/' + constants.selectedCalendar + '/users/' + localStorage.getItem('userId') + "/tees", headers)

            let upcomingTees = []
            if (payload.data && payload.data.tickets) {

                payload.data.tickets.forEach(function (ticket) {
                    if (moment(new Date(ticket.eventInfo.startDate)).isSameOrAfter(moment(new Date()).startOf('day'))) {
                        upcomingTees.push(ticket);
                    }

                });
                console.log(payload.data.tickets)
                dispatchSuccessWrap(actionTypes.GET_FUTURE_TEE_TICKETS, {
                    tickets: upcomingTees
                }, dispatch)
                cb()
            } else {
                cb()
                dispatchErrorWrap(actionTypes.ERROR, dispatch)
            }

        } catch (error) {
            //cb()
            cb()
            dispatchErrorWrap(actionTypes.ERROR, dispatch)

        }


    }
}

export const deleteCard = (cardId, customerId, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            },
            data: {
                cardId: cardId
            }
        }



        try {
            const payload = await axios.delete(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/removeCard", headers)

            dispatchSuccessWrap(actionTypes.DELETE_CARD, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }
}

export const updatePayTerms = (customerId, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        var data = {
            recurringPayTermsAgreedOn: moment().format('llll')
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/payTerms", data, headers)

            dispatchSuccessWrap(actionTypes.UPDATE_PAY_TERMS, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}

export const addNewCard = (token, customerId, payTermsAndCond, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        var data = {
            stripeToken: token
        }
        if (!payTermsAndCond) {
            // If no previously paid terms and conditions
            data.recurringPayTermsAgreedOn = moment().format('llll');
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/addCard", data, headers)
            if (payload.data && payload.data.card) {
                let dataForMakingDefault = {
                    cardId: payload.data.card.id
                }
                await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", dataForMakingDefault, headers)
            }
            dispatchSuccessWrap(actionTypes.ADD_CARD, { resp: payload }, dispatch)
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}

export const addNewBankAcct = (token, customerId, payTermsAndCond, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        var data = {
            stripeToken: token
        }

        if (!payTermsAndCond) {
            // If no previously paid terms and conditions
            data.recurringPayTermsAgreedOn = moment().format('llll');
        }
        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/addCard", data, headers)
            if (payload.data && payload.data.card) {
                /* let dataForMakingDefault = {
                     cardId: payload.data.card.id
                 }*/
                // await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", dataForMakingDefault, headers)
                dispatchSuccessWrap(actionTypes.ADD_BANK_ACCT, { resp: payload }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}


export const addNewBankAcctAndMakeDefault = (token, customerId, payTermsAndCond, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        var data = {
            stripeToken: token
        }

        if (!payTermsAndCond) {
            // If no previously paid terms and conditions
            data.recurringPayTermsAgreedOn = moment().format('llll');
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/addCard", data, headers)
            if (payload.data && payload.data.card) {
                let dataForMakingDefault = {
                    cardId: payload.data.card.id
                }
                await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", dataForMakingDefault, headers)
                dispatchSuccessWrap(actionTypes.ADD_BANK_ACCT, { resp: payload }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }
}


export const verfiySource = (customerId, source, amt1, amt2, cb) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            source: source,
            amt1: amt1,
            amt2: amt2
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/verify", data, headers)
            if (payload.data && payload.data.card) {
                let dataForMakingDefault = {
                    cardId: payload.data.card.id
                }
                await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/customer/' + customerId + '/user/' + localStorage.getItem('userId') + "/default", dataForMakingDefault, headers)
                dispatchSuccessWrap(actionTypes.VERIFY_SOURCE, { resp: payload }, dispatch)
            }
            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }

    }

}


export const updateBillingMethod = (billingMethod, subscriptionId) => {
    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            billingMethod: billingMethod
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/subscription/' + subscriptionId + '/billingMethod', data, headers)
            console.log(payload)
            // dispatchSuccessWrap(actionTypes.NAME_CHANGE, { resp: payload }, dispatch)

        } catch (error) {
        }

    }
}



export const changeAllcalName = (name) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const data = {
            name: name
        }

        try {
            const payload = await axios.put(constants.apiUrl + '/accounts/' + localStorage.getItem('userId'), data, headers)
            console.log(payload)
            dispatchSuccessWrap(actionTypes.NAME_CHANGE, { resp: payload }, dispatch)

        } catch (error) {
        }
    }
}

export const updateInfoForPaperMember = (updateObj, loginToken, isNoPayFirstTimeMember, emailIdForNewCreation, cb) => {
    return async (dispatch) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': loginToken
            }
        }

        if (updateObj.dateOfBirth) {
            updateObj.dateOfBirth = new Date(updateObj.dateOfBirth).toISOString();

        }
        if (isNoPayFirstTimeMember) {
            updateObj.isNoPaySelfRegisterOrLogin = true;
        }

        if (emailIdForNewCreation) {
            updateObj.emailIdForNewCreation = emailIdForNewCreation;
        }


        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/paper', updateObj, headers)
            dispatchSuccessWrap(actionTypes.UPDATED_MEMBER_INFO, { resp: payload }, dispatch)

            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }


    }
}



export const updateMemberInfo = (linkToSavedMember, phoneNumber, address, dateOfBirth, emergencyContact, emergencyContactName, cb, mailingAddress) => {

    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        const updateObj = {
            allcalUserId: localStorage.getItem('userId')
        }
        if (linkToSavedMember) {
            updateObj.linkToSavedMember = linkToSavedMember;
        }
        if (phoneNumber) {
            updateObj.phoneNumber = parseInt(phoneNumber);
        }
        if (address) {
            updateObj.address = address;
        }
        if (dateOfBirth) {
            updateObj.dateOfBirth = dateOfBirth;
        }
        if (emergencyContact) {
            updateObj.emergencyContact = parseInt(emergencyContact);
        }
        if (emergencyContactName) {
            updateObj.emergencyContactName = emergencyContactName;
        }
        if (mailingAddress) {
            updateObj.mailingAddress = mailingAddress;
        }

        try {
            const payload = await axios.put(constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/paper', updateObj, headers)
            dispatchSuccessWrap(actionTypes.UPDATED_MEMBER_INFO, { resp: payload }, dispatch)

            cb(payload.data.error, payload)

        } catch (error) {
            cb('error')
        }
    }

}

export const getSavedMemberInfo = (memberId, callback) => {
    return async (dispatch, getState) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        try {
            const payload = await axios.get(constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg + '/member/' + memberId, headers);
            if (payload.data && !payload.data.error && payload.data) {
                callback(null, payload.data.data);
            } else {
                callback('No member info found')
            }
        } catch (err) {
            callback(err);
        }
    }
}

export const updateNameAndEmailAcrossPlatforms = (name, email, memberId) => {
    return async () => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }
        const dataToUpdate = {
            name, 
            email
        }
        try {
            const payload = await axios.put(constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg + '/member/' + memberId, dataToUpdate, headers);
            if (!payload.data.error && payload.data) {
                localStorage.setItem('email', payload.data.data?.email)
                localStorage.setItem('userName', payload.data.data?.name)
            } 
        } catch (err) {
            console.log(err)
        }
    }
}

export const getUpcomingInvoice = (custId, callback) => {
    return async (dispatch, getState) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }
        try {
            const payload = await axios.get(constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg + '/cust/' + custId, headers);
            if (payload.data && !payload.data.error && payload.data) {
                callback(null, payload.data.data);
            } else {
                callback('No upcoming invoice found')
            }
        } catch (err) {
            callback(err);
        }
    }
}



export const getUserInfo = (userId, cb) => {
    return async (dispatch, getState) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {
            const payload = await axios.get(constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg + '/user/undefined/stripe/customer?email=' + encodeURIComponent(localStorage.getItem('email')), headers);

            let payloadPaper = await axios.get(constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg + '/user/' + userId + '/paper', headers);
            if (payloadPaper.data.error) {
                payloadPaper = await axios.get(constants.dashboardBaseUrl + "/organization/" + constants.selectedOrg + '/user/undefined/paper?email=' + encodeURIComponent(localStorage.getItem('email')), headers);

            }
            let payloadRegInfo = await axios.get(constants.dashboardBaseUrl + "/org/" + constants.selectedOrg + '/user/' + userId + '/registrationInfo', headers);
            if (payloadRegInfo.data.error) {
                payloadRegInfo = await axios.get(constants.dashboardBaseUrl + "/org/" + constants.selectedOrg + '/user/undefined/registrationInfo?email=' + encodeURIComponent(localStorage.getItem('email')), headers);

            }
            let consolidatedRespData = {};
            let stripeUserInfo = {};
            let paperInfo = {}
            let regUserInfo = {}
            if (payload.data && payload.data.data) {
                console.log(payload.data);
                stripeUserInfo = payload.data.data
                let futureInvoiceItems = []
                let cardSources = []
                stripeUserInfo.invoiceItems.forEach((invoice) => {
                    // if (moment(invoice.date * 1000).isSameOrAfter(moment(new Date()).startOf('month'))) {
                    futureInvoiceItems.push(invoice);
                    // }
                })

                stripeUserInfo.sources && stripeUserInfo.sources.data && stripeUserInfo.sources.data.length > 0 && stripeUserInfo.sources.data.forEach((card) => {
                    //if (card.object === 'card') {
                    cardSources.push(card)
                    //}
                })
                stripeUserInfo.invoiceItems = futureInvoiceItems;
                if (stripeUserInfo.sources &&
                    stripeUserInfo.sources.data) {
                    stripeUserInfo.sources.data = cardSources
                }
            } else {
                stripeUserInfo.stripeUserInfoExists = false;
            }
            if (payloadPaper.data && payloadPaper.data.data) {
                paperInfo = payloadPaper.data.data
            } else {
                paperInfo.paperInfoExists = false;
            }

            if (payloadRegInfo.data && payloadRegInfo.data.data) {
                regUserInfo = payloadRegInfo.data.data
            } else {
                regUserInfo.regUserInfoExists = false
            }

            consolidatedRespData = {
                ...stripeUserInfo,
                ...paperInfo,
                ...regUserInfo
            }
            console.log(consolidatedRespData)
            //console.log('payload cal Info', payload);
            dispatchSuccessWrap(actionTypes.GET_USER_INFO, {
                consolidatedRespData: consolidatedRespData
            }, dispatch)
            cb(null, consolidatedRespData)

        } catch (error) {
            dispatchErrorWrap(actionTypes.ERROR, dispatch)
            cb('Error fetching user info')
        }

    }
}

/*
export const getPaperInfoForUser = (userId, cb) => {
    return async (dispatch, getState) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {

            //console.log('payload cal Info', payload);
            if (payload.data && payload.data.data) {
                dispatchSuccessWrap(actionTypes.GET_PAPER_INFO, {
                    paperInfo: payload.data.data
                }, dispatch)
            } else {
                dispatchErrorWrap(actionTypes.ERROR, dispatch)
            }

        } catch (error) {
            dispatchErrorWrap(actionTypes.ERROR, dispatch)
        }

    }
} */
/*
export const getRegistrationInfoForUser = (userId, cb) => {
    return async (dispatch, getState) => {

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {

            //console.log('payload cal Info', payload);
            if (payload.data && payload.data.data) {
                dispatchSuccessWrap(actionTypes.GET_REGISTRATION_INFO, {
                    regInfo: payload.data.data
                }, dispatch)
            } else {
                dispatchErrorWrap(actionTypes.ERROR, dispatch)
            }

        } catch (error) {
            dispatchErrorWrap(actionTypes.ERROR, dispatch)
        }

    }
} */
